import { Chip } from "components/DesignSystem/Chips/Chips";
import {
  FILTER_END_DATE,
  FILTER_ETD_DUE_TODAY,
  FILTER_ETD_END_DATE,
  FILTER_ETD_OVERDUE,
  FILTER_ETD_SELECT_PERIOD,
  FILTER_ETD_START_DATE,
  FILTER_ETD_UNSET,
  FILTER_SELECT_PERIOD,
  FILTER_START_DATE,
} from "../Task1120FilterOptions";
import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";
import { ColumnHeaderDateFilter } from "../../ReusableHeaderFilter/ColumnHeaderDateFilter";

type BoolUpdateFilter = (name: string, value: boolean | null) => void;

export const ETDCalendarHeader = ({
  values,
  updateFilter,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: (name: string, value: string) => void;
}) => {
  const boolUpdate = updateFilter as unknown as BoolUpdateFilter;

  const isActive = Boolean(
    values.ETD_START_DATE ||
      values.ETD_END_DATE ||
      values.UNSET ||
      values.OVERDUE ||
      values.DUE_TODAY
  );

  const handleClearFilter = () => {
    updateFilter(FILTER_ETD_START_DATE, "");
    updateFilter(FILTER_ETD_END_DATE, "");
    updateFilter(FILTER_ETD_SELECT_PERIOD, "");
    boolUpdate(FILTER_ETD_UNSET, null);
    boolUpdate(FILTER_ETD_OVERDUE, null);
    boolUpdate(FILTER_ETD_DUE_TODAY, null);
  };

  const handleDateChange = (name: string, value: string) => {
    switch (name) {
      case FILTER_START_DATE:
        updateFilter(FILTER_ETD_START_DATE, value);
        break;
      case FILTER_END_DATE:
        updateFilter(FILTER_ETD_END_DATE, value);
        break;
      case FILTER_SELECT_PERIOD:
        updateFilter(FILTER_ETD_SELECT_PERIOD, value);
        break;
      default:
        break;
    }
  };

  const etdToggles = (
    <div className="t-flex t-gap-2 t-flex-wrap t-mb-3">
      {[
        {
          label: "No ETD",
          key: FILTER_ETD_UNSET,
          active: Boolean(values.UNSET),
        },
        {
          label: "Overdue",
          key: FILTER_ETD_OVERDUE,
          active: Boolean(values.OVERDUE),
        },
        {
          label: "Due today",
          key: FILTER_ETD_DUE_TODAY,
          active: Boolean(values.DUE_TODAY),
        },
      ].map(({ label, key, active }) => (
        <Chip
          key={key}
          isActive={active}
          filterType={key}
          onClick={() => boolUpdate(key, active ? null : true)}
          onRemove={() => boolUpdate(key, null)}
          isFixedFilter
        >
          {label}
        </Chip>
      ))}
    </div>
  );

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>ETD</div>
      <ColumnHeaderDateFilter
        isActive={isActive}
        values={values}
        updateFilter={handleDateChange}
        handleClearFilter={handleClearFilter}
        skipMaxEndDate
        topContent={etdToggles}
      />
    </div>
  );
};
